import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc1a4b9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }

import SearchComponent from '@/components/SearchComponent.vue';
import TimeAndCalendar from '@/components/TimeAndCalendar.vue';
import ModelBtn from '@/components/ModelBtn';
import { settings } from '@/store/settings';

export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleMode',
  setup(__props) {

const handleChange = () => {
  settings.isSimple = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ModelBtn), { onHandleChange: handleChange }),
    _createVNode(SearchComponent, { class: "search-bar" }),
    _createVNode(TimeAndCalendar)
  ]))
}
}

})